import * as React from "react";
const SvgRepeats = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M13.3346 6.66683V4.5335C13.3346 3.41339 13.3346 2.85334 13.1166 2.42552C12.9249 2.04919 12.6189 1.74323 12.2426 1.55148C11.8148 1.3335 11.2547 1.3335 10.1346 1.3335H5.86797C4.74786 1.3335 4.18781 1.3335 3.75999 1.55148C3.38366 1.74323 3.0777 2.04919 2.88596 2.42552C2.66797 2.85334 2.66797 3.41339 2.66797 4.5335V11.4668C2.66797 12.5869 2.66797 13.147 2.88596 13.5748C3.0777 13.9511 3.38366 14.2571 3.75999 14.4488C4.18781 14.6668 4.74786 14.6668 5.86797 14.6668H8.0013",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M8.33203 7.33317H5.33203M5.9987 9.99984H5.33203M10.6654 4.6665H5.33203",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_17534_20201)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M12.2782 14.1112L11.4449 13.2779M11.4449 13.2779L12.2782 12.4446M11.4449 13.2779H12.8338C13.9077 13.2779 14.7782 12.4073 14.7782 11.3334C14.7782 10.5578 14.324 9.88819 13.6671 9.57612M10.3338 13.0908C9.67684 12.7787 9.22266 12.1091 9.22266 11.3334C9.22266 10.2596 10.0932 9.389 11.1671 9.389H12.556M12.556 9.389L11.7227 8.55566M12.556 9.389L11.7227 10.2223",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round"
})), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_17534_20201" }, /* @__PURE__ */ React.createElement("rect", {
	width: 6.66667,
	height: 6.66667,
	fill: "currentColor",
	transform: "translate(8.66797 8)"
}))));
export default SvgRepeats;
